<template>
  <div>
    <a-modal :visible="previewVisible" :footer="null" width="40%" :get-container="getModalContainer" @cancel="handleCancel">
      <img v-if="images.length" :src="images[0]" alt="预览图片" style="width: 100%" />
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    mindMap: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      images: [],
      previewVisible: false
    };
  },
  mounted() {
    this.mindMap.on('node_img_dblclick', this.onNodeImgDblclick);
  },
  beforeDestroy() {
    this.mindMap.off('node_img_dblclick', this.onNodeImgDblclick);
  },
  methods: {
    onNodeImgDblclick(node, e) {
      e.stopPropagation();
      e.preventDefault();
      this.images = [node.nodeData.data.image];
      this.previewVisible = true;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    getModalContainer() {
      return document.getElementById('mindMapContainer');
    }
  }
};
</script>

<style></style>
